import React, { PropTypes } from 'react';
import pluralize from 'pluralize';
import { Dialog, FontIcon } from 'material-ui';
import SimpleTemplateList from '../../template-list/simple-template-list';
import { connect } from 'react-redux';
import {
  toggleAssoicatedTemplates as toggleAssoicatedTemplatesAction,
} from '../__storeFiles__/actions';

const AssociatedTemplateListDialog = props => {
  const {
    open,
    toggleAssoicatedTemplates,
    doc: {
      templates = [],
    },
    typeLabel,
  } = props;
  return (
    <Dialog
      open={open}
      title={<div className="flex-tc-sb">
        {
          templates.length
        } Associated {
        pluralize('Template', templates.length)
      }
        <div onClick={toggleAssoicatedTemplates}>
          <FontIcon className="tc-icon-close" style={{ fontSize: '24px', cursor: 'pointer' }} />
        </div>
      </div>}
      onRequestClose={toggleAssoicatedTemplates}
      bodyStyle={{ padding: '6px 16px', marginTop: '1px' }}
      autoScrollBodyContent
    >
      {
        templates.length
          ? (
            <SimpleTemplateList
              templates={templates}
            />
          )
          : (
            <div style={{ padding: '32px 0' }}>
              This {
              typeLabel
            } template is not assoicated with any templates.
            </div>
          )
      }
    </Dialog>
  );
};

AssociatedTemplateListDialog.propTypes = {
  open: PropTypes.bool,
  toggleAssoicatedTemplates: PropTypes.func,
  doc: PropTypes.object,
  typeLabel: PropTypes.string,
};

const mapStateToProps = ({
 contracting: {
   masterTemplate: { docs },
 },
}) => {
  return {
    open: docs.showAssociatedTemplates,
    doc: docs[docs.currentId] || {},
  };
};
export default connect(mapStateToProps, {
  toggleAssoicatedTemplates: toggleAssoicatedTemplatesAction,
})(AssociatedTemplateListDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/dialogs/associated-template-list.jsx